module.exports = __webpack_public_path__ + "static/media/email.3329bdf0.svg";